import wineProductFieldMapFactory from '../mappers/wineProductFieldMapFactory'
import vcShopProductFieldMapFactory from '../mappers/vcShopProductFieldMapFactory'
import posProductFieldMapFactory from '../mappers/posProductFieldMapFactory'
import posFoodProductFieldMapFactory from '../mappers/posFoodProductFieldMapFactory'
import posModifierProductFieldMapFactory from '../mappers/posModifierProductFieldMapFactory'

export default {
  'wine-product': wineProductFieldMapFactory,
  'shop-product': vcShopProductFieldMapFactory,
  'pos-product': posProductFieldMapFactory,
  'pos-food-product': posFoodProductFieldMapFactory,
  'pos-modifier-product': posModifierProductFieldMapFactory
}

